var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTrevo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1587,
    height: 831,
    viewBox: "0 0 1587 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M878.548 0H1251.5L863.53 831H490.581L878.548 0Z",
    fill: "#EAF5FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.08 0H1586.91L1198.94 831H926.114L1314.08 0Z",
    fill: "#ECF3FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M810.976 0H565.684H387.967H55.0693V282.84H255.918L0 831H423.009L810.976 0Z",
    fill: "#ECF3FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrevo);
export default __webpack_public_path__ + "static/media/LogoTrevo.88fc90cbfcd0da23e955c5ab7e396c87.svg";
export { ForwardRef as ReactComponent };